import React, { useState } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import Sidebar from './components/Sidebar'
import i18next from 'i18next'
import { useLocation, useNavigate } from 'react-router'
import FormQuestions from './components/FormQuestions'
import { compressBase64Image, serviceDown } from './utils/UtilityFunctions'
import { postApi } from './api/services'
import MainLoader from './components/MainLoader'

const DoctorRegistration = () => {

  const navigate = useNavigate()
  const location = useLocation()

  const [isLoading, setIsLoading] = useState(false)
  const [formValues, setFormValues] = useState({
    first_name: '',
    last_name: '',
    c_name: '',
    c_address: '',
    city: '',
    postal_code: '',
    country: '',
    latitude: '',
    longitude: '',
    license_number: '',
    email: '',
    signature: ''
  });

  const formQuestions = [
    {
      title: "First Name",
      type: "text",
      placeholder: "Enter first name",
      commonIdentifier: "first_name",
      questionId: 1
    },
    {
      title: "Last Name",
      type: "text",
      placeholder: "Enter last name",
      commonIdentifier: "last_name",
      questionId: 2
    },
    {
      title: "Clinic Name",
      type: "text",
      placeholder: "Enter clinic name",
      commonIdentifier: "c_name",
      questionId: 3
    },
    {
      title: "Clinic Address",
      type: "address",
      placeholder: "Enter clinic address",
      commonIdentifier: "c_address",
      questionId: 4
    },
     {
      title: "Email",
      type: "email",
      placeholder: "Enter email",
      commonIdentifier: "email",
      questionId: 5
    },
    {
      title: "License Number",
      type: "alphanumeric",
      placeholder: "Enter license number",
      commonIdentifier: "license_number",
      questionId: 6
    },
    {
      title: "Signature",
      type: "signature",
      placeholder: "Upload signature",
      commonIdentifier: "signature",
      questionId: 7
    },
  ];

  const handleFormValues = async (value, identifier) => {
    let processedValue = value;

    if (identifier === "signature") {
      processedValue = await compressBase64Image(value);
    }

    setFormValues((prev) => {
      const updated = { ...prev };

      switch (identifier) {
        case "first_name":
          updated.first_name = processedValue;
          break;
        case "last_name":
          updated.last_name = processedValue;
          break;
        case "c_name":
          updated.c_name = processedValue;
          break;
        case "c_address":
          updated.c_address = processedValue.address;
          updated.latitude = processedValue.lat;
          updated.longitude = processedValue.lng;
          updated.city = processedValue.city;
          updated.postal_code = processedValue.postalCode;
          updated.country = processedValue.country;
          break;
        case "license_number":
          updated.license_number = processedValue;
          break;
        case "email":
          updated.email = processedValue;
          break;
        case "signature":
          updated.signature = processedValue;
          break;
        default:
          break;
      }
      return updated;
    });
  }

  const handleSubmit = async () => {
    if(
      formValues.first_name === '' || 
      formValues.last_name === '' || 
      formValues.c_name === '' ||
      formValues.c_address === '' ||
      formValues.email === '' || 
      formValues.license_number === '' || 
      formValues.signature === ''
    ) {
      swal({
        title: i18next.t("Please fill all the fields"),
        icon: "warning",
      })
    } else {
      setIsLoading(true)
      let params = {
        first_name: formValues.first_name,
        last_name: formValues.last_name,
        license_number: formValues.license_number,
        signature_base64: formValues.signature,
        clinic_name: formValues.c_name,
        clinic_address: formValues.c_address,
        city: formValues.city,
        postal_code: formValues.postal_code,
        country: formValues.country,
        phone_number: localStorage.getItem('phno'),
        email: formValues.email,
        latitude: formValues.latitude,
        longitude: formValues.longitude
      }
      console.log("add_doctor params", params);
      try {
        let res = await postApi('add_doctor', params)
        console.log("add_doctor res", res);
        if(res?.message) {
          setIsLoading(false)
          localStorage.setItem('doctorLogged', true)
          getDoctor()
        }
      } catch (err) {
        console.log("err", err);
        // await trackEvent('check_user', 'fail', err, localStorage.getItem('phno'))
        setIsLoading(false)
        serviceDown('/loginpage')
      }
    }
  }

  const getDoctor = async () => {
    setIsLoading(true)
    let params = {
      phone_number: localStorage.getItem("phno")
    }
    console.log("get_doctor_by_phone params", params);
    try {
      let res = await postApi('get_doctor_by_phone', params)
      console.log("get_doctor_by_phone res", res);
      setIsLoading(false)
      if(res?.doctor_exist){
        sessionStorage.setItem("checkUser", JSON.stringify(res));
        localStorage.setItem('doctorobj', JSON.stringify(res))
        navigate('/clientinsights');
      }
    } catch (err) {
      console.log("err", err);
      // await trackEvent('check_user', 'fail', err, localStorage.getItem('phno'))
      setIsLoading(false)
      serviceDown('/loginpage') 
    }
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='docRegPage photo-container main-section-container'>
        <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
          <Grid item xs={1} className=''>
            {/* <div className='d-flex justify-content-start align-items-center'>
              <span className='backButtonDiv' onClick={() => navigate(-1)}>
                <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
              </span>
            </div> */}
          </Grid>
          <Grid item xs={10} className='d-flex justify-content-center align-items-center'>
            <Typography variant="h6" className="title">{i18next.t("Clinic Registration")}</Typography>
          </Grid>
          <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
            <Sidebar from={location?.pathname}/>
          </Grid>
        </Grid>
        <div className='patientregpage-questions-container'>
          {formQuestions?.length > 0 && formQuestions.map((ele) => {
            return (
              <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                <FormQuestions 
                  element={ele} 
                  handleFormValues={handleFormValues}
                  formValues={formValues}
                />
              </Grid>
            )
          })}
          <Button className='submitButton commonButton mt-10px' variant="contained" onClick={handleSubmit}>
            {i18next.t("Submit")}
          </Button>
        </div>
      </div>
    </>
  )
}

export default DoctorRegistration